import wixLocation from 'wix-location';

$w.onReady( () => {
	let url = wixLocation.url;
	if (url.includes("/post/404")) {wixLocation.to("/blog");}
})